import React, { useContext } from 'react';

import { Upload } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { EditableListButton, EditableListButtonProps } from './EditableListButton';
import { WhiteboardSessionContext } from '../../context/WhiteboardSessionContext';

export type ImportPdfButtonProps = Omit<EditableListButtonProps, 'title' | 'icon' >;
export const ImportPdfButton = (props: ImportPdfButtonProps) => {
    const { t } = useTranslation('whiteboard');
    const { whiteboardSessionState } = useContext(WhiteboardSessionContext);

    const renderTitle = () => {
        if (whiteboardSessionState.templatePage) {
            return t('import-pdf-to-control-page');
        }

        return t('import-pdf-to-pages');
    };

    return (
        <EditableListButton
            {...props}
            key={'import-pdf'}
            title={renderTitle()}
            icon={<Upload />}
        />
    );
};
